import { render, staticRenderFns } from "./PayNowSettings.vue?vue&type=template&id=25c5ef62&"
import script from "./PayNowSettings.vue?vue&type=script&lang=js&"
export * from "./PayNowSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports